module.exports = __webpack_public_path__ + "static/img/left-navigation-logo-icon.a9f872e.svg";


//////////////////
// WEBPACK FOOTER
// ./static/prism/images/left-navigation-logo-icon.svg
// module id = ltqB
// module chunks = 74